/* eslint-disable eag/no-css-property */
/* eslint-disable react-js/forbid-component-props */
import {ContentEditable} from '@lexical/react/LexicalContentEditable';
import {css} from 'styled-components';

export function Input() {
  return (
    <ContentEditable
      css={css`
        width: 100%;
        font-size: ${({theme}) => theme.fontSizes.text.small};
        line-height: ${({theme}) => theme.lineHeights.text.xxSmall};
        color: ${({theme}) => theme.colors.text.secondary};
        outline: none;
        z-index: 1;
        position: relative;
        min-height: 100%;
        max-height: ${({theme}) => theme.getSize(25)};
        overflow: auto;
        padding: 13px 0;
        display: flex;
        flex-direction: column;
        > *:first-child {
          margin-top: auto;
        }
        > *:last-child {
          margin-bottom: auto;
        }

        @media (max-width: 768px) {
          font-size: max(16px, ${({theme}) => theme.fontSizes.text.small});
        }

        > p {
          margin: 0;
        }

        a {
          color: ${({theme}) => theme.colors.palettes.blue[60][100]};
          text-decoration: underline;
          cursor: pointer;

          &:hover {
            color: ${({theme}) => theme.colors.palettes.blue[80][100]};
          }
        }
      `}
    />
  );
}
